import { render, staticRenderFns } from "./RegistrationCredit.vue?vue&type=template&id=ddb6c5b0&scoped=true"
import script from "./RegistrationCredit.vue?vue&type=script&lang=js"
export * from "./RegistrationCredit.vue?vue&type=script&lang=js"
import style0 from "./RegistrationCredit.vue?vue&type=style&index=0&id=ddb6c5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb6c5b0",
  null
  
)

export default component.exports